const __request = require(`./__request/__request_contentType_json`);

// 退票订单数量
const recordCount = (data) => {
let pParameter = {
    method: 'post',
    // urlSuffix: '/flight/domestic/buyer/manage/order/refundRecordCount',
    urlSuffix:'/buyer/dom/manage/refundCount',
    data:data
  }

  return __request(pParameter)
}
export default recordCount
